import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react'
import DataTable from 'src/components/tables/DataTable';
import { colDefs } from './constants';
import { useNavigate } from 'react-router-dom';
import { getArchivedOrganizations, getOrganizations } from 'src/view-models/Organization';
import Loading from 'src/components/loading/Loading';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';
import DeleteModal from './components/DeleteModal';

const Organizations = () => {
  const dispatch = useAppDispatch()
  const navigation = useNavigate()

  const {organizations,status} = useAppSelector((state)=>state.organization)
  const [isLoading,setIsLoading] = useState(true)

  const goToAddOrganization = () => {
    navigation('/admin/organizations/new')
  }

  useEffect(() => {
    const fetchOrganizations = async () => {
      if(status === 1) {
        setIsLoading(true)
        await getOrganizations(dispatch)
      }else{
        setIsLoading(true)
        await getArchivedOrganizations(dispatch)
      }
      setIsLoading(false)
    }
    fetchOrganizations()
  }, [status])

  if(isLoading){
    return <Loading />
  }

  return (
    <Box  px={4} py={2} rounded={4}  >
      <DeleteModal />
      <Flex height={'100px'} flexDirection={{base:'column',md:'row'}} alignItems={{base:'flex-start',md:'center'}} justifyContent='space-between' gap={4} >
        <Box>
          <Text color='#4E5D78' fontWeight={700} fontSize={30} >Organizations</Text>
          <Text color='#4E5D78'>Sur cette page, vous pouvez gérer tous les aspects concernant Établissements </Text>
        </Box>
        <Button colorScheme='blue' onClick={goToAddOrganization} >Ajouter Un Établissement</Button>
      </Flex>
      <Box my={8} >
        <DataTable columns={colDefs} data={organizations} />
      </Box>
    </Box>
)
}

export default Organizations